"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var contexts_1 = require("../../contexts");
var base_1 = require("../../themes/base");
var utils_1 = require("../../utils");
var StyledAlinta_1 = require("./StyledAlinta");
var Alinta = /** @class */ (function (_super) {
    tslib_1.__extends(Alinta, _super);
    function Alinta() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            responsive: undefined
        };
        _this.onResize = function () {
            var _a = _this.state, theme = _a.theme, responsive = _a.responsive;
            if (theme) {
                var breakpoint = utils_1.getBreakpoint(window.innerWidth, theme);
                if (breakpoint !== responsive) {
                    _this.setState({ responsive: breakpoint });
                }
            }
        };
        return _this;
    }
    Alinta.getDerivedStateFromProps = function (nextProps, prevState) {
        var theme = nextProps.theme;
        var stateTheme = prevState.theme, themeProp = prevState.themeProp;
        var nextTheme;
        if (!theme && (themeProp || !stateTheme)) {
            nextTheme = base_1.base;
        }
        if (nextTheme) {
            var colors = (nextTheme.global || base_1.base.global).colors;
            var color = colors.background;
            var dark = color ? utils_1.colorIsDark(color) : false;
            return {
                theme: tslib_1.__assign(tslib_1.__assign({}, nextTheme), { dark: dark }),
                themeProp: theme
            };
        }
        return null;
    };
    Alinta.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    };
    Alinta.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    Alinta.prototype.render = function () {
        var _a = this.props, children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
        delete rest.theme;
        var _b = this.state, responsive = _b.responsive, theme = _b.theme; // Type theme to
        return (React.createElement(contexts_1.ThemeContext.Provider, { value: theme },
            React.createElement(contexts_1.ResponsiveContext.Provider, { value: responsive },
                React.createElement(StyledAlinta_1.StyledAlinta, tslib_1.__assign({}, rest, { theme: theme }), children))));
    };
    return Alinta;
}(React.Component));
exports.Alinta = Alinta;
//# sourceMappingURL=Alinta.js.map